//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ManufacturerPostDialog from "@/views/admin/ManufacturerPostDialog";
import OccupationalSafetyPostDialog from "@/views/admin/OccupationalSafetyPostDialog";
export default {
  name: "ProcessPostList",
  props: {
    posts: {
      required: true,
      type: Array
    }
  },
  methods: {
    selectInfo(post) {
      if(post.post_type === 'herstellerinfo') {
        this.$refs.manufacturerPostDialog.show(post);
      }
      if(post.post_type === 'as-info') {
        this.$refs.occupationalSafetyPostDialog.show(post);
      }
    }
  },
  components: {
    ManufacturerPostDialog,
    OccupationalSafetyPostDialog
  }
}
